<template>
  <div class="table-list-page">
    <search-nav v-if="showNav" @handleSearch="onClickSearch">
      <slot name="search">
        <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
          <component
            v-for="(component, index) in stdSearchComponents"
            v-if="showSearchNavItem(component['options'])"
            :key="`stdSearchComponents_${index}`"
            :is="component['component']"
            :label="$t(component['label'])"
            :query="component['query']"
            :options="component['options']"
            :onClickSearch="onClickSearch"
            v-model="nav.value[component['value']]"
          />
        </div>
      </slot>
    </search-nav>
    <div class="flex" v-if="selectList">
      <vs-tabs v-model="selectTab" class="mr-auto">
        <vs-tab :label="$t('검색 결과')" />
        <vs-tab :label="`${$t('선택된 문서')} (${selectList.length})`" />
      </vs-tabs>
      <div class="ml-auto flex" style="gap: 0.5rem">
        <vs-button v-if="selectTab === 0" color="secondary" style="min-width: 180px" @click="onSelectAll">{{ $t("전체선택") }}</vs-button>
        <vs-button :color="selectList.length > 0 ? 'secondary' : 'gray'" style="min-width: 180px" @click="onClickAction">{{ selectListActionLabel }}</vs-button>
      </div>
    </div>
    <div class="flex justify-end gap-4 w-full text-right px-4 xl:px-0">
      <slot name="toolRight"></slot>
      <!-- <vs-button v-if="download" class="mr-4" color="secondary" type="border" @click="onClickDownload">{{ $t("button.Excel 다운로드") }} </vs-button> -->
      <vs-button v-if="hasAdminPermission && useExcelDownloadList" class="mb-4 flex-1 xl:flex-none" color="secondary" type="border" @click="onClickExcelDownload">{{ $t("List Excel 다운로드") }}</vs-button>
      <vs-button v-if="hasAdminPermission && useExcelDownloadPosts" class="mb-4 flex-1 xl:flex-none" color="secondary" type="border" @click="onClickSelectDownload">{{ $t("선택 후 엑셀다운로드") }}</vs-button>
      <vs-button v-if="multiPrint" class="mr-4 mb-4 py-0 pl-6 hidden xl:block" color="secondary" type="border" @click="onClickMultiPrint">
        <div class="flex items-center">
          <feather-icon icon="PrinterIcon" svgClasses="h-6 w-6" class="mr-1" />
          <span class="my-3">{{ $t("선택 후 인쇄") }}</span>
        </div>
      </vs-button>
      <vs-button v-if="approval && permission.c" color="secondary" type="border" @click="onClickApprovalLine" class="mb-4 flex-1 xl:flex-none">{{ $t("button.결재선 지정") }} </vs-button>
      <vs-button v-if="create && permission.c" color="secondary" @click="onClickNew" class="mb-4 flex-1 xl:flex-none">{{ $t(createBtnLabel) }} </vs-button>
      <vs-button v-if="multipleDelete && permission.d" :disabled="selectedIds.length === 0" color="secondary" type="border" @click="onClickMultipleDelete" class="mb-4 flex-1 xl:flex-none">{{ $t("선택삭제") }}</vs-button>
    </div>

    <vx-card :class="cardClass">
      <vs-table
        class="pb-wide"
        color="success"
        style="min-width:100%; width:auto;"

        ref="table"
        :sst="true"
        :data="translatedList"
        no-data-text=""
        @sort="onClickSort"
        @selected="onClickDetail"
      >

        <!--헤더-->
        <template slot="thead">
          <vs-th v-if="multipleDelete && permission.d" style="width: 44px; min-width: 44px; text-align: center"><span class="w-full text-center">{{ $t("선택") }}</span></vs-th>
          <vs-th v-if="baseColumn" sort-key="No" style="width: 60px; min-width: 60px; text-align: center"><span class="w-full text-center">No.</span></vs-th>
          <vs-th
            v-for="head in heads"
            :key="`table_header_${head.name}`"
            class="page-head"
            :class="head.class"
            :style="{ ...head.style, width: `${(approval ? 90 : 96) / heads.length}%` }"
            style="text-align: center"
            :sort-key="head.keyName"
          >
            <span class="w-full">{{ $t(head.name) }}</span>
          </vs-th>
          <vs-th v-if="baseColumn && useFinishLater" sort-key="문서상태" style="min-width: 100px"
            ><span class="w-full text-center">{{ $t("문서상태") }}</span></vs-th
          >
          <vs-th v-if="baseColumn && boardSlug && approval" sort-key="결재상태" style="min-width: 100px; width: 100px; text-align: center"
            ><span class="w-full text-center">{{ $t("결재상태") }}</span></vs-th
          >
          <vs-th v-if="baseColumn && moveProject" style="min-width: 200px; width: 200px"
            ><span class="w-full text-center">{{ $t("보기") }}</span></vs-th
          >
        </template>

        <!--본문영역-->
        <template slot-scope="{ data }">
          <vs-tr v-if="data.length === 0">
            <!--            <vs-td colspan="100">-->
            <!--              <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px;">-->
            <!--                <feather-icon icon="AlertTriangleIcon" class="mr-2"/>-->
            <!--                표시할 데이터가 없습니다.-->
            <!--              </div>-->
            <!--            </vs-td>-->
          </vs-tr>
          <template v-else>
            <vs-tr v-for="(tr, ri) in data" :data="tr" :key="ri" :style="fontSize ? { fontSize } : {}" :class="selectList && tr.raw && selectList.findIndex((item) => item.id === tr.raw.id) >= 0 ? 'selectItem' : ''">
              <vs-td v-if="multipleDelete && permission.d" class="text-center">
                <div v-if="canDeleteRow(tr)" @click.native.stop @click.stop class="inline-block">
                  <vs-checkbox v-model="selectedIds" :vs-value="tr.postId" />
                </div>
                <div v-else @click.native.stop @click.stop class="inline-block">
                  <vx-tooltip :text="$t('작성자만 삭제가 가능합니다.')" position="top">
                    <vs-checkbox :value="false" disabled />
                  </vx-tooltip>
                </div>
              </vs-td>
              <vs-td v-if="baseColumn" class="text-center">
                {{ tr["No"] }}
              </vs-td>

              <vs-td v-for="(head, ci) in heads" :key="`table_list_${ri}_${ci}_${head.name}`" class="text-center" :style="{ ...head.style, width: `${(approval ? 90 : 96) / heads.length}%` }">
                <div v-if="typeof tr[head.name] === 'object'">
                  <div v-if="tr[head.name] && tr[head.name].type === 'file'">
                    <a download target="_blank" :href="img.path" v-for="(img, index) in tr[head.name].files" :key="index" @click.stop>
                      <vs-icon icon-pack="feather" icon="icon-file" />
                    </a>
                  </div>
                  <div v-else-if="tr[head.name] && tr[head.name].type === 'image'">
                    <a download target="_blank" :href="tr[head.name].url" @click.stop>
                      <vs-image style="width: 120px; height: 120px" :src="tr[head.name].url" />
                    </a>
                  </div>
                  <div v-else-if="tr[head.name] && tr[head.name].type === 'image-center'">
                    <a download target="_blank" :href="tr[head.name].url" style="display: flex; align-items: center; justify-content: center" @click.stop>
                      <vs-image style="width: 120px; height: 120px" :src="tr[head.name].url" />
                    </a>
                  </div>
                  <div v-else-if="tr[head.name] && tr[head.name].type === 'pre'">
                    <div style="white-space: pre-line; text-align: left">{{ tr[head.name].value }}</div>
                  </div>
                  <div v-else-if="tr[head.name] && tr[head.name].type === 'pre-center'">
                    <div style="white-space: pre-line; text-align: center">{{ tr[head.name].value }}</div>
                  </div>
                  <div v-else-if="tr[head.name] && tr[head.name].type === 'member'">
                    <div class="w-full" style="text-align: center">{{ getMemberName(tr[head.name].memberId) }}</div>
                  </div>
                  <div v-else-if="tr[head.name]">
                    <span :class="tr[head.name].type">{{ tr[head.name].value }}</span>
                    <span v-if="tr[head.name].type === 'up' || tr[head.name].type === 'down'" style="display: inline-flex; padding-top: 2px; width: 20px; height: 20px; max-height: 20px">
                      <vs-image class="w-full" :src="require(`@/assets/images/icon/Icon-arrow_${tr[head.name].type}.png`)" />
                    </span>
                  </div>
                </div>
                <div v-else style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap" :title="tr[head.name] ? tr[head.name] : '　'">
                  {{ tr[head.name] ? tr[head.name] : "　" }}
                </div>
              </vs-td>

              <vs-td v-if="baseColumn && useFinishLater" class="text-center">{{ tr["문서상태"] }}</vs-td>
              <vs-td v-if="baseColumn && boardSlug && approval" class="text-center">
                {{ tr["결재상태"] }}
              </vs-td>

              <vs-td v-if="baseColumn && moveProject" class="text-center" @click.stop>
                <div class="flex justify-center" @click.stop>
                  <vs-button
                    type="border"
                    icon="open_in_new"
                    class="mr-1"
                    @click.stop="
                      () => {
                        onClickDetail(tr, '_blank');
                      }
                    "
                  ></vs-button>
                  <vs-button
                    type="border"
                    @click.stop="
                      () => {
                        onClickDetail(tr, 'self');
                      }
                    "
                    >{{ $t("button.바로가기") }}
                  </vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </template>
      </vs-table>

      <div v-if="translatedList.length === 0">
        <div colspan="100">
          <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px"><feather-icon icon="AlertTriangleIcon" class="mr-2" />{{ $t("표시할 데이터가 없습니다.") }}</div>
        </div>
      </div>

      <!--페이지네이션-->
      <div class="vs-con-table" v-if="selectTab === 0">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage" :max-items="5" v-model="page" @change="onChangePage"></k-pagination>
        </div>
      </div>
    </vx-card>

    <popup-approval-process v-if="approval" :show-popup="popup.approval" @closePopup="onClickClose" />
    <popup-excel-download v-if="download" v-model="popup.excel" :list="excelList" :title="title" />
  </div>
</template>

<script>
/* eslint-disable */
import PopupExcelDownload from "@/popup/PopupExcelDownload";
import PopupApprovalProcess from "@/views/approval/PopupApprovalProcess";
import SearchNav from "@/components/nav/SearchNav";
import KPagination from "@/components/kPagination/kPagination";
import singlePageList from "@/views/boards/single-page/listIndex";
import searchComponent from "@/views/list/components/include";
import HttpRequest from "@/util/HttpRequest";
import {marked} from "marked";
import * as UiUtil from "@/util/UiUtil";

export default {
  name: "TableListPage",
  components: {
    KPagination,
    SearchNav,
    PopupApprovalProcess,
    PopupExcelDownload,
  },
  props: {
    detail: Function,
    list: {
      required: false,
      type: Array,
    },
    // list 를 api 를 통해 불러오지 않고, props 의 list 를 사용하는지에 대한 여부
    useList: Boolean,
    baseColumn: {
      type: Boolean,
      default: true,
    },
    bodyStyle: {
      type: String,
      default: "card",
    },
    showNav: {
      type: Boolean,
      default: true,
    },
    download: {
      type: Boolean | String,
      default: true,
    },
    approval: {
      type: Boolean,
      default: false,
    },
    create: {
      type: Boolean,
      default: true,
    },
    createBtnLabel: {
      type: String,
      default() {
        return this.$t("신규작성");
      },
    },
    moveProject: {
      type: Boolean,
      default: false,
    },
    moveDetail: {
      type: Boolean,
      default: true,
    },
    moveNew: {
      type: Boolean,
      default: true,
    },
    byCurrentLocation: {
      type: Boolean,
      default: false,
    },
    boardSlug: String,
    boardId: Number | String,
    routeC: String,
    routeU: String,

    fontSize: String,
    nav: Object,
    heads: Array,
    getCol: Function,
    perPage: {
      type: Number,
      default: () => {
        return 10;
      },
    },
    querySearchMode: {
      type: Boolean,
      default: false,
    },
    useFinishLater: {
      type: Boolean,
      default: false,
    },
    multiPrint: Boolean,
    selectList: Array,
    selectType: {
      type: String,
      default: "print",
    },
    moveBoard: Number,
    moveBoardBtnLabel: {
      type: String,
      default: "위험성 결과 결재",
    },
    useExcelDownloadList: {
      type: Boolean,
      default: false,
    },
    useExcelDownloadPosts: {
      type: Boolean,
      default: false,
    },
    multipleDelete: {
      type: Boolean,
      default: false,
    },
    funcLoading: Function,
  },
  data() {
    return {
      searchComponent,
      popup: {
        excel: false,
        approval: false,
      },
      page: 1, // 현재 페이지 번호
      total: 0, // 총 데이터 개수
      lastPage: 1, // 마지막 페이지 번호
      sortKey: "",
      orderTarget: "created_at",
      orderBy: null,
      listAll: [],
      // 엑셀 다운로드를 위해서 전체 불러온 데이터
      listAllExcel: [],
      tableList: [],

      // 번역된 데이터
      translatedList: [],
      permission: {
        c: false,
        r: false,
        u: false,
        d: false,
      },
      selectTab: 0,

      // 목록 선택삭제: 페이지 이동 시에도 유지
      selectedIds: [],

      // 마지막 api 호출시 사용한 옵션
      apiLastLoadOptions: null,
    };
  },
  watch: {
    list() {
      this.listAll = this.list;
    },
    parsedListForTable () {
      this.translateList();
    },
    async pageTranslate () {
      if (this.pageTranslate) {
        UiUtil.loading(true)
        await this.translateList()
        UiUtil.loading(false)
      }
    }
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    cardClass() {
      if (this.bodyStyle === "none") {
        return "none-card";
      }
      return "";
    },
    hasAdminPermission() {
      return parseInt(this.$store.state.auth.userInfo.is_superuser) === 1;
    },
    currentUserId() {
      return this.$store.state.auth.userInfo.id;
    },
    selectListActionLabel() {
      if (this.selectType.toLowerCase() === "print") return this.$t("선택 후 인쇄");
      else if (this.selectType.toLowerCase() === "exceldownload") return $t("선택 후 다운로드");
      else if (this.selectType.toLowerCase() === "selectupdate") return $t("종료일 일괄 등록");
      return "";
    },
    title() {
      if (typeof this.download === "string") {
        return this.download;
      }
      return "unknown";
    },
    getPage() {
      const query = this.$route.query;
      if (query && query.pg) {
        try {
          return Number(query.pg) > 0 ? Number(query.pg) : 1;
        } catch (e) {}
      }
      return 1;
    },
    stdSearchComponents() {
      if (singlePageList[`${this.boardId}_list`]) {
        const getComponents = singlePageList[`${this.boardId}_list`].components;
        if (getComponents) {
          const stdSearchComponents = getComponents();
          if (stdSearchComponents && stdSearchComponents.length > 0) {
            for (const component of stdSearchComponents) {
              component.component = searchComponent[component["component"]];
            }
          }
          return stdSearchComponents;
        }
      }
      return [];
    },
    /**
     * 테이블 본문에 해당하는 리스트를 작성해서 반환한다
     */
    parsedListForTable() {
      // 선택된 문서를 별도로 볼 수 있는 탭을 선택하면, 테이블의 리스트가 선택된 문서 리스트로 변경된다.
      const rawList = this.selectTab && this.selectTab === 1 ? this.selectList : this.listAll;
      return this.parsedListForTableWithList(rawList);
    },
    excelList() {
      const info = singlePageList[`${this.boardId}_list`];
      if (info && info.getHead) {
        const _head = info.getHead();
        const list = this.parsedListForTableWithList(this.listAllExcel).map((_pl) => {
          const _row = { No: _pl.No };
          _head.map((_h) => {
            _row[_h.name] = _pl[_h.name];
          });

          return _row;
        });

        return list;
      }

      return [];
    },

    realList() {
      return this.excelList;
    },

    initSortData() {
      const _query_keys = ["_sort", "_order"];
      const query = this.$route.query;
      const query_sort = query[_query_keys[0]];
      const query_order = query[_query_keys[1]];
      const data = {
        sort: query_sort || "",
        order: query_order || "",
      };
      return data;
    },

    pageTranslate () {
      return this.$store.state.menu.pageTranslate;
    },
  },
  async created() {
    this.page = this.getPage;
    this.sortKey = this.initSortData.sort;
    this.orderBy = this.initSortData.order;

    // 게시판일 경우, 권한을 확인한다
    if (Number.isInteger(parseInt(this.boardId))) {
      let boards = this.$store.state.member.memberInfo.boards;
      if (!boards) {
        await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
        boards = this.$store.state.member.memberInfo.boards;
      }

      let board = boards.find((b) => parseInt(b.id) === parseInt(this.boardId));
      if (!!board && !!board.pivot) {
        if (board.pivot.project_id) {
          // 프로젝트에 맞는 권한이 있는지 다시 조사한다
          board = boards.find((b) => parseInt(b.pivot.board_id) === parseInt(this.boardId) && parseInt(b.pivot.project_id) === parseInt(this.projectId));
          this.permission = { ...board.pivot };
        } else {
          this.permission = { ...board.pivot };
        }
      }

      // console.log(this.boardId, boards, board)
      // console.log(this.permission);
    }

    // list를 두번 부르는 이슈가 있어서 주석처리 (boardId : 433)
    // created 에서 loadList 의 호출이 필요할 경우, 별도 처리가 필요할 듯 하다.
    // if (!this.useList) {
    //   console.log("이게 실행된거구나?")
    //   await this.loadList();
    // }
  },
  mounted() {
    // 이벤트버스를 통해서 검색어가 변경되었을 때, 리스트를 다시 불러온다
    if (this.$eventbus) {
      this.$eventbus.$on("keyword-search", (/*keyword*/) => {
        this.loadList();
      });
    }
  },
  methods: {
    initSort() {
      const { sortKey, orderBy } = this;
      // 정렬 순서가 정해졌을 때에만 해당 컬럼의 정보를 추출한다
      if (orderBy) {
        this.orderDirection = orderBy;
        const target = this.getColumnKey(sortKey);
        if (target) {
          this.orderTarget = target;
        } else {
          // 만약 target이 없다면, 해당 컬럼의 정보를 찾아서 정렬한다
          const target = this.findKeyWithHead(sortKey);
          this.orderTarget = target || "created_at";
        }
      }
      // 정렬이 해제될 때에는 기본 컬럼을 "created_at"으로 설정한다
      else {
        this.orderDirection = "desc";
        this.orderTarget = "created_at";
        if (singlePageList[`${this.boardId}_list`].getDefaultSort) {
          const sort = singlePageList[`${this.boardId}_list`].getDefaultSort();
          this.orderTarget = sort.target;
          this.orderDirection = sort.order;
        }
      }
    },
    initSearchKeyValue() {
      let keyValue = {};
      let keyword = [];

      if (singlePageList[`${this.boardId}_list`]) {
        keyValue = singlePageList[`${this.boardId}_list`].getSearchKeyValue(this.nav);
        keyword = singlePageList[`${this.boardId}_list`].getSearchKeyword(this.nav);
      }

      if (keyword) {
        keyword = keyword.map((_keyword) => {
          return _keyword
            .replace("field_id", `nav.page.p${this.$route.params.boardId}.fieldId`)
            .replace("default_skw", `nav.page.p${this.$route.params.boardId}.searchKeyword`)
            .replace("default_disaster", `nav.page.p${this.$route.params.boardId}.disasterType`);
        });
      }

      if (this.nav) {
        this.nav.page[`p${this.boardId}`] = keyValue;
        this.nav.keyword = keyword;
      }
    },
    initSearchConditions() {
      const func = singlePageList[`${this.boardId}_list`] && singlePageList[`${this.boardId}_list`].getConditions;
      if (func) {
        this.nav.conditions = func(this.nav);
      }
    },

    async translateList () {
      // this.parsedListForTable 의 value 값을 키로 하는 새로운 json 객체를 생성하여, 번역 API 를 호출한다.
      let translatedList = {};
      this.parsedListForTable.map(item => {
        const keys = Object.values(item);
        for (const key of keys) {
          if (typeof key === "string" && key.length > 0 && key !== 'raw') {
            translatedList[key] = key;
          } else {
            // 만약 key가 object 이라면, 해당 object의 value를 키로 사용한다
            if (key != null && typeof key === "object" && key.value) {
              translatedList[key.value] = key.value;
            }
          }
        }
        return {}
      });

      if( Object.keys(translatedList).length > 0 && this.pageTranslate) {
        // 번역
        try {
          await HttpRequest.post('/api/v1/miras/translate', {
            origin: translatedList,
            toLang: this.$i18n.locale,
          }).then((response) => {
            if (response.data) {
              translatedList = response.data;
            }
          }).catch((error) => {
            console.error("Error loading translation data:", error);
          });
        } catch (e) {
          console.log("translateList error", e)
        }
      }

      this.translatedList = this.parsedListForTable.map((item) => {
        return {
          ...item,
          // 번역된 값을 적용한다
          ...Object.keys(item).reduce((acc, key) => {
            // 만약 item[key]가 object라면, 해당 object의 value를 사용한다
            if (typeof item[key] === "string") {
              if (translatedList[item[key]]) {
                acc[key] = translatedList[item[key]];
              } else {
                acc[key] = item[key];
              }
            } else if (item[key] != null && typeof item[key] === "object" && item[key].value) {
              // object의 value를 사용한다
              acc[key] = translatedList[item[key].value] ? translatedList[item[key].value] : item[key].value;
            } else {
              acc[key] = item[key];
            }

            return acc;
          }, {}),
        };
      })
      console.log("this.translatedList", this.translatedList)
    },

    getMemberName(memberId) {
      const list = this.$store.state.member.listAll;
      for (const member of list) {
        if (Number(`${member.id}`) === Number(`${memberId}`)) {
          return member.name;
        }
      }

      return "";
    },

    async loadList(forExcelDownload = false) {
      let projectId = this.$route.params.proj_id;
      if (this.nav && this.nav.projectId) {
        projectId = this.nav.projectId;
      }

      this.initSort();
      this.initSearchKeyValue();
      this.initSearchConditions();

      if (this.approval) {
        await this.loadListApproval(projectId, forExcelDownload);
      } else {
        await this.loadListBoard(projectId, forExcelDownload);
      }
    },

    async loadListBoard(projectId, forExcelDownload = false) {
      const boardId = this.boardId;
      const conditions = this.nav && this.nav.conditions ? this.nav.conditions : [];
      if (!boardId) {
        return;
      }
      let page = this.page;
      let perPage = this.perPage;
      let orderTarget = this.orderTarget;
      let orderDirection = this.orderDirection;
      if (forExcelDownload) {
        page = 1;
        perPage = 10000;
        orderTarget = "id";
        orderDirection = "asc";
      }

      let companies = this.nav && this.nav.value && this.nav.value.companies && this.nav.value.companies.length > 0 ? this.nav.value.companies : [];
      if (`${boardId}` === "433" && this.$store.state.company.companyTree) {
        const navValue = this.nav.value;
        companies = [];
        const depth = this.$store.state.company.companyTree
          .filter((item) => {
            if (navValue.companyTree && navValue.companyTree.path) {
              return item.company_path.indexOf(navValue.companyTree.path) === 0;
            } else if (navValue.company0) {
              if (navValue.company1) {
                if (navValue.company2) {
                  return item.company_path.indexOf(`${navValue.company0}/${navValue.company1}/${navValue.company2}/`) === 0;
                } else {
                  return item.company_path.indexOf(`${navValue.company0}/${navValue.company1}/`) === 0;
                }
              } else {
                return false; //item.company_path.indexOf(`${navValue.company0}/`) === 0; // companyId가 너무 많아 호출 오류가 발생하여 주석처리
              }
            } else {
              return false;
            }
          })
          .map((item) => {
            return {
              value: item.descendant_id,
              text: item.descendant.com_name,
            };
          });

        for (const dep of depth) {
          companies.push(dep.value);
        }
      }
      const companyIds = [...companies];

      let dateTarget = "created_at";
      let dateBegin = "";
      let dateEnd = "";
      const keywords = [];

      if (this.nav && this.nav.dateTarget) {
        dateTarget = this.nav.dateTarget;
      }

      if (this.nav && this.nav.dateBegin) {
        dateBegin = this.getValue(this.$props, this.nav.dateBegin);
      }

      if (this.nav && this.nav.dateEnd) {
        dateEnd = this.getValue(this.$props, this.nav.dateEnd);
      }

      if (this.nav && this.nav.keyword && this.nav.keyword.length > 0) {
        try {
          this.nav.keyword.map((word) => {
            if (word.substr(0, 14) === "customKeyword_") {
              keywords.push(word.substr(14));
            } else {
              const methods = `${word}`.split("*");
              const key = methods[1].replace(/%*\[\:([^%]*)\]%*/, "$1");
              const value = this.getValue(this.$props, key);
              const query = methods[1].replace(/(%*)([^%]*)(%*)/, `$1${value}$3`);
              const keyword = `${methods[0]}*${query.trim()}`;

              //const key
              if (value) {
                keywords.push(keyword);
              }
            }
          });
        } catch (e) {}
      }

      // 추후보완 관련
      if (this.nav.value.isFinishLater) {
        keywords.push("content$body.isFinishLater*true");
      }

      const options = {
        projectId: projectId > 0 ? projectId : undefined,
        boardId,
        page,
        perPage,
        orderTarget,
        orderDirection,
        companyIds,

        dateTarget,
        dateBegin,
        dateEnd,

        conditions,
        keyword: keywords,
      };

      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);

      if (forExcelDownload) {
        this.listAllExcel = response.data;
      } else {
        this.listAll = response.data;
        this.total = response.total;
        this.lastPage = response.last_page;
        this.page = this.page > this.lastPage ? this.lastPage : this.page;

        this.$emit("load", this.listAll);
      }
    },

    async loadListApproval(projectId, forExcelDownload = false) {
      const boardSlug = this.boardSlug;
      const conditions = this.nav && this.nav.conditions ? this.nav.conditions : [];
      let page = this.page;
      let perPage = this.perPage;
      let orderTarget = this.orderTarget;
      let orderDirection = this.orderDirection;
      if (forExcelDownload) {
        page = 1;
        perPage = 10000;
        orderTarget = "id";
        orderDirection = "asc";
      }
      const dateTarget = [];
      const dateBegin = [];
      const dateEnd = [];
      const keywords = [];
      const companies = this.nav.value && this.nav.value.companies && this.nav.value.companies.length > 0 ? this.nav.value.companies : [];
      const companyIds = [...companies];

      if (this.nav.keyword && this.nav.keyword.length > 0) {
        try {
          this.nav.keyword.map((word) => {
            const methods = `${word}`.split("*");
            const key = methods[1].replace(/%*\[\:([^%]*)\]%*/, "$1");
            const value = this.getValue(this.$props, key);
            const query = methods[1].replace(/(%*)([^%]*)(%*)/, `$1${value}$3`);
            const keyword = `${methods[0]}*${query.trim()}`;
            //const key
            if (value) {
              keywords.push(keyword);
            }
          });
        } catch (e) {}
      }

      if (this.nav.dateTarget) {
        if (typeof this.nav.dateTarget === "string") {
          dateTarget.push(this.nav.dateTarget);
        } else {
          dateTarget.push(...this.nav.dateTarget);
        }
      }

      if (this.nav.dateBegin && this.nav.dateBegin.length > 0) {
        if (typeof this.nav.dateBegin === "string") {
          dateBegin.push(this.getValue(this.$props, this.nav.dateBegin));
        } else {
          this.nav.dateBegin.map((key) => {
            dateBegin.push(this.getValue(this.$props, key));
          });
        }
      }

      if (this.nav.dateEnd && this.nav.dateEnd.length > 0) {
        if (typeof this.nav.dateEnd === "string") {
          dateEnd.push(this.getValue(this.$props, this.nav.dateEnd));
        } else {
          this.nav.dateEnd.map((key) => {
            dateEnd.push(this.getValue(this.$props, key));
          });
        }
      }

      const options = {
        boardSlug,
        projectId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd,
        keyword: keywords,
        orderTarget,
        orderDirection,
        companyIds,
        conditions,
      };

      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));

      const response = await this.$store.dispatch("approval/LOAD_POST_ALL", options);

      if (forExcelDownload) {
        this.listAllExcel = response.data;
      } else {
        this.listAll = response.data;
        this.total = response.total;
        this.lastPage = response.last_page;
        // this.listAll = [...JSON.parse(JSON.stringify(this.$store.state.approval.list))];
        // this.total = this.$store.state.approval.postListInfo.total;
        this.$emit("load", this.listAll);
      }
    },

    getValue(obj, keyPath) {
      const keys = `${keyPath}`.split(".");
      let value = obj;
      for (const key of keys) {
        value = value[key] ? value[key] : "";
      }
      return value;
    },

    onClickSearch() {
      this.page = 1;
      this.selectTab = 0;

      if (this.querySearchMode) {
        this.onSearchMovePage();
      } else {
        this.loadList();
      }
    },
    // 정렬해야 하는 데이터 컬럼 정보를 불러온다
    getColumnKey(column) {
      const params = { value: { searchType: column } };

      const target = singlePageList[`${this.boardId}_list`].getSearchKeyword(params);

      // 만약 target이 배열이고, 개수가 1개 이상이어야 다음으로 진행할 수 있다
      if (Array.isArray(target) && target.length > 0) {
        // target을 * 문자로 잘라서, 첫번째 내용을 this.orderTarget에 입력한다
        return target[0].split("*")[0];
      }

      return null;
    },
    onClickSort(sortKey, orderBy) {
      this.sortKey = sortKey;
      this.orderBy = orderBy;

      if (sortKey === null) {
        return;
      }
      this.loadList();
    },
    async onChangePage(page) {
      this.page = page;
      if (this.querySearchMode) {
        this.onSearchMovePage();
      } else {
        await this.loadList();
      }
    },
    onClickApprovalLine() {
      this.popup.approval = true;
    },
    onClickNew() {
      if (this.moveNew) {
        const boardId = this.boardId;
        const query = this.$route.query;
        const pageType = "write";
        this.$router.push({
          name: this.routeC,
          params: { boardId, pageType },
          query,
        });
      } else {
        this.$emit("new");
      }
    },
    onClickClose() {
      const keys = Object.keys(this.popup);
      keys.map((key) => {
        this.popup[key] = false;
      });
    },
    onClickDetail(value, target) {
      if (!value.postId) return;

      let proj_id = this.projectId;
      if (this.byCurrentLocation) proj_id = this.projectId;

      const boardId = this.boardId;
      const boardSlug = this.boardSlug;
      const postId = value.postId;
      const query = this.$route.query;
      const pageType = "write";
      const route = {
        name: this.routeU,
        params: {
          proj_id,
          boardId,
          boardSlug,
          postId,
          pageType,
        },
        query,
      };

      if (this.moveProject) {
        if (target === "self") {
          if (route.params.boardId === 50) {
            this.$router.push({ name: route.name, params: { proj_id, postId, tab: "info" } });
          } else {
            this.$router.push(route);
          }
          return;
        } else if (target === "_blank") {
          if (route.params.boardId === 50) {
            window.open(`/project/${proj_id}/plan/partners/info/${postId}`, "_blank");
          } else {
            const routeData = this.$router.resolve(route);
            window.open(routeData.href, "_blank");
          }
          return;
        }
      } else if (this.moveDetail) {
        this.$router.push(route);
      }

      this.$emit("detail", value, target, route);
    },

    onSearchMovePage() {
      // url query 문 생성
      let search = JSON.parse(JSON.stringify(this.nav.value));
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query["pg"] = this.page;

      const searchKeys = Object.keys(search);
      if (searchKeys.length > 0) {
        for (const key of searchKeys) {
          if (key === "searchKeyword") {
            if (search.searchKeyword) {
              query["keyword"] = search.searchKeyword.trim();
            }
          } else if (key === "companies") {
            if (search.companies && search.companies.length > 0) {
              query["companies"] = search.companies;
            }
          } else if (key === "isFinishLater") {
            query["fl"] = search.isFinishLater;
          } else if (key === "yearMonth") {
            if (search.yearMonth.year) {
              query["year"] = search.yearMonth.year;
            }

            if (search.yearMonth.month) {
              query["month"] = search.yearMonth.month;
            }
          } else {
            if (search[key]) {
              if (typeof search[key] === "object") {
                if (search[key].sDate && search[key].sDate.trim()) {
                  query["sd"] = search[key].sDate.trim();
                }

                if (search[key].eDate && search[key].eDate.trim()) {
                  query["ed"] = search[key].eDate.trim();
                }
              } else {
                query[key] = search[key];
              }
            }
          }
        }
      }

      if (this.isJsonEmpty(search)) {
        // search (nav.value) 가 비어 있는 경우는 컴포너트가 생성되지 않은 경우 이므로, 컴포넌트의  query 데이터를 사용하여, search 데이터를 미리 넣어준다.
        if (this.stdSearchComponents && this.stdSearchComponents.length > 0) {
          const obj = {};
          for (const component of this.stdSearchComponents) {
            const _component_query = component.query;

            if (_component_query) {
              const keys = Object.keys(_component_query);
              for (const key of keys) {
                const data = _component_query[key];
                this.stringToObj(data, this.$route.query[key] || "", obj);
              }
            }
          }
          search = obj;
        }
      }

      // 기존 코드가 생성한 query 데이터를 제거한다
      if (this.stdSearchComponents && this.stdSearchComponents.length > 0) {
        const _urlQuery = query;
        if (_urlQuery) {
          const _queryKeys = Object.keys(_urlQuery);
          for (const key of _queryKeys) {
            delete query[key];
          }
        }
      }

      // 컴포넌트의 query 데이터를 사용하여, URL 쿼리에 데이터를 넣어준다.
      if (this.stdSearchComponents && this.stdSearchComponents.length > 0) {
        for (const component of this.stdSearchComponents) {
          const _queryObject = component.query;
          if (_queryObject) {
            const _queryKeys = Object.keys(_queryObject);
            for (const key of _queryKeys) {
              if (_queryKeys.length === 1) {
                query[key] = this.findJsonDataWithDottedPath(search, `${component.value}`);
              } else {
                query[key] = this.findJsonDataWithDottedPath(search, `${component.value}.${_queryObject[key]}`);
              }
            }
          }
        }
      }

      // 쿼리의 빈값을 제거한다
      const queryKeys = Object.keys(query);
      for (const key of queryKeys) {
        if (!query[key]) {
          delete query[key];
        }
      }

      this.onMoveNormalPage("list", query);
    },

    isJsonEmpty(json) {
      return Object.keys(json).length === 0;
    },

    // dotted path를 통해서 json 데이터를 찾는다
    // ex> findJsonDataWithDottedPath({a: {b: {c: 1}}}, 'a.b.c') => 1
    findJsonDataWithDottedPath(json, path) {
      try {
        const _keys = Object.keys(json);
        if (_keys.length === 0) {
          return "";
        }
        const paths = path.split(".");
        let result = json;
        for (const p of paths) {
          result = result[p];
        }
        return result;
      } catch (err) {
        return "";
      }
    },
    stringToObj(path, value, obj) {
      const parts = path.split(".");
      const last = parts.pop();
      let part;
      while ((part = parts.shift())) {
        if (typeof obj[part] != "object") obj[part] = {};
        obj = obj[part]; // update "pointer"
      }
      obj[last] = value;
    },

    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    findKeyWithHead(sortKey) {
      if (singlePageList[`${this.boardId}_list`]) {
        const heads = singlePageList[`${this.boardId}_list`].getHead().map((e) => {
          return { [e.name]: e.key };
        });
        // 배열의 객체들을 하나의 객체로 합치기
        const types = Object.assign({}, ...heads);
        return `content$${types[sortKey]}`;
      }
    },

    onMoveNormalPage(type, query) {
      const proj_id = `${this.projectId}`;
      const boardId = `${this.boardId}`;
      if (type === "list") {
        this.$router.push({ name: "list|tab", params: { pageType: "list", proj_id, boardId }, query }).catch(async (e) => {
          if (e.toString().indexOf("NavigationDuplicated") >= 0) {
            await this.loadList();
          }
        });
      }
    },

    canDeleteRow(tr) {
      return this.hasAdminPermission || parseInt(tr.raw.user_id) === parseInt(this.currentUserId);
    },
    onClickMultiPrint() {
      this.$emit("clickMultiPrint");
    },
    async onClickMultipleDelete() {
      if (this.selectedIds.length === 0) return;
      if (!confirm(this.$t("선택한 항목을 삭제하시겠습니까?"))) return;
      const boardId = this.boardId;
      for (const postId of this.selectedIds) {
        await this.$store.dispatch("board/DELETE_POST", { boardId, postId });
      }
      this.selectedIds = [];
      this.apiLastLoadOptions = null;
      await this.loadList();
      this.$toast.open({ type: "success", message: this.$t("삭제가 완료되었습니다."), position: "bottom", duration: 2000 });
    },

    onSelectAll() {
      if (this.parsedListForTable && this.parsedListForTable.length > 0) {
        this.$emit("selectAll", this.parsedListForTable);
      }
    },
    onClearAll() {
      this.$emit("clearAll");
    },
    onClickAction() {
      this.$emit("selectAction");
      if (this.selectType.toLowerCase() === "print") this.onClickPrint();
      else if (this.selectType.toLowerCase() === "exceldownload") this.onClickExcelDownload();
    },
    onClickPrint() {
      if (this.selectList && this.selectList.length > 0) {
        this.$emit("selectPrint");
      }
    },

    onClickSelectDownload() {
      this.$emit("clickSelectDownload");
    },
    async onClickExcelDownload() {
      await this.loadList(true);
      if (this.funcLoading) this.funcLoading(true);
      await this.$nextTick();
      setTimeout(async () => {
        if (singlePageList[`${this.boardId}_list`].customExcelDownload) {
          await singlePageList[`${this.boardId}_list`].customExcelDownload(this.listAllExcel, `${this.download}_${this.nav.value.year}`);
        } else this.popup.excel = true;

        if (this.funcLoading) this.funcLoading(false);
      }, 300);
    },

    parsedListForTableWithList(rawList) {
      const tableList = [];
      let idx = this.selectTab === 0 ? this.total : 1;
      for (const item of rawList) {
        const row = {};
        const content = item.post_content ? JSON.parse(item.post_content).body : {};
        row.projId = item.project_id;
        row.postId = item.post_id || item.id;
        // if (this.boardSlug) {
        //   row["No"] = item.post_id;
        // } else {
        //   row["No"] = item.id;
        // }
        for (let ci = 0; ci < this.heads.length; ci++) {
          row[this.heads[ci].name] = this.getCol(ci, item);
        }
        if (this.boardSlug) {
          if (item.document_status) {
            row["결재상태"] = item.document_status.name;
          } else {
            row["결재상태"] = "-";
          }
        }
        if (content) {
          row["문서상태"] = content.isFinishLater ? "추후보완" : "완료";
        }
        row["raw"] = item;

        if (this.selectTab === 0) {
          row["No"] = idx - (this.page - 1) * this.perPage;
        } else {
          // 선택된 문서(팝업용)
          row["No"] = idx;
        }
        idx += this.selectTab === 0 ? -1 : 1;

        if (this.getRowStyle) {
          row.style = this.getRowStyle(item);
        }

        tableList.push(row);
      }

      return tableList;
    },
  },
};
</script>

<style lang="scss" scoped>
.table-list-page {
  .page-head {
    min-width: 180px !important;
  }
}
</style>
<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0px;
  display: inline-block;

  .vx-card__body {
    padding: 0px !important;
  }
}

span.up {
  color: #28c76f;
}
span.down {
  color: #ea5455;
}
.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}

.selectItem:nth-child(even) {
  background-color: #7e72f238 !important;
}
.selectItem:nth-child(odd) {
  background-color: #7e72f226 !important;
}
.table-list-page table {
  table-layout: fixed !important;
}
.table-list-page .vs-con-table table {
  width: auto;
  min-width: 100%;
}
</style>
